import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from 'react-router-dom';
import App from "./App";
import AuthProvider from "react-auth-kit";
import createStore from "react-auth-kit/createStore";

import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";

const store = createStore({
    authName:'_auth',
    authType:'cookie',
    cookieDomain: window.location.hostname,
    cookieSecure: window.location.protocol === 'https:',
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <AuthProvider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </AuthProvider>
);